import { defineComponent, getCurrentInstance, PropType, reactive, watchEffect } from 'vue'
import { IContainer } from '../../json-parse/src/interface'
import CompMenu from './widgets/comp-menu'
import CompCanves from './widgets/comp-canves'
import CompOption from './widgets/comp-option'
import compTree from './widgets/comp-tree'
import TopBar from './widgets/top-bar'
import UEI from './use/useEditInfo'
import { basicLayout } from "../../json-parse/src/tools/register";
import deepcopy from 'deepcopy'
import './style/index.scss'

export default defineComponent({
  name: 'KJsonEdit',
  components: { CompMenu, CompCanves, CompOption, compTree },
  props: {
    // 布局容器
    layout: {
      type: Object as PropType<IContainer>,
      default: () => (basicLayout)
    },
    // 远程数据
    mock: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['close-canvas', 'submit-option'],
  setup(props, ctx) {
    const state = reactive({
      scaleOperate: false, // option操作栏状态(是否缩放)
      showTree: false,
    })
    // 更新全局绑定的数据
    watchEffect(() => {
      let tempLayout = props.layout
      if(toString.call(tempLayout) !== '[object Object]') {
        tempLayout = deepcopy(basicLayout)
      } else {
        if(!tempLayout.isroot) tempLayout.isroot = true
      }
      UEI.setGlobalLayout(tempLayout)
    })
    // 更新全局绑定的数据
    watchEffect(() => {
      UEI.setMockData(props.mock)
    })
    // 关闭编辑状态
    function closeCanvas() {
      ctx.emit('close-canvas')
    }
    // 显示组件树
    function showCompTree() {
      state.showTree = !state.showTree
    }
    // 放大/缩小可操作栏目
    function scaleOption() {
      state.scaleOperate = !state.scaleOperate
    }
    // 提交修改的布局
    function submitOption() {
      ctx.emit('submit-option', {layout: UEI.state.globalLayout, mock: UEI.state.mockData})
    }

    return () => {
      return ( 
        <div class="json-test-box">
          { state.showTree ? <compTree/> : null }
          <div class="top-bar-wrap">
            <TopBar closeCanvas={closeCanvas} showCompTree={showCompTree}/>
          </div>
          <div class="comp-canves-wrap" id="comp-canves-wrap">
            <CompCanves />
          </div>
          <div class="comp-option-wrap" style={state.scaleOperate?{width:'500px'}:{}}>
            <CompOption scaleOption={scaleOption} submitOption={submitOption}/>
          </div>
          <div class="comp-menu-wrap">
            <CompMenu/>
          </div>
        </div>
      )
    }
  }
})
